<!-- src/App.vue -->
<script setup lang="ts">
import { onMounted } from 'vue'
import { initFlowbite } from 'flowbite'
import { useHead } from '@unhead/vue'

useHead({
  titleTemplate: (title) => title ? title : 'Smart Teacher',
})

onMounted(() => initFlowbite())
</script>

<template>
  <div class="antialiased flex flex-col min-h-screen">
    <!-- <TopNavBar v-if="user" /> -->
    <router-view />
  </div>
</template>
